class SiteNavigation {

    private navigationUrl: ISiteNavigationUrl[] = 
        [
            new SiteNavigationUrlListGroupId(),
            new SiteNavigationUrlArticleGroupId(),

            new SiteNavigationUrlListGroups(),
            new SiteNavigationUrlArticleGroups(),
            new SiteNavigationUrlArticleSorts(),
            new SiteNavigationUrlArticleHeight(),
            new SiteNavigationUrlArticleWidth(),
            new SiteNavigationUrlBaseColors(),
            new SiteNavigationUrlIndex(),
            new SiteNavigationUrlManufacturerSuppliers(),
            new SiteNavigationUrlPrice(),
            new SiteNavigationUrlTags(),
            new SiteNavigationUrlLocations(),
            new SiteNavigationUrlFavorites(),
            new SiteNavigationUrlQuery(),
            new SiteNavigationUrlOrderBy()
        ]
    

    getUrl(filters: ISiteFilterModel) {

        let url = "/Assortment/";

        if (filters.listGroup != null && filters.listGroup.length > 0)
            url += `${filters.listGroup}/`;
        else
            url += "All/";

        if (filters.articleGroupId != null && filters.articleGroupId.length > 0)
            url += `${filters.articleGroupId}/`;

        for (let navigation of this.navigationUrl) {
            
            let partUrl = navigation.appendUrl(filters);
            if (partUrl) {
                url += `${navigation.category}=${partUrl}/`;
            }
        }

        return url;
    }
    parseUrl(model: ISiteFilterModel, url: string) {
        let parts = url.split("/");
        let split = /([^=]+)=(.*)/;

        // We always get /Assortment/ so start with 2
        if (parts.length > 2) {
            let x = 3;
            // Our first part is always the listGroupId
            model.listGroup = parts[2];

            // Our second part MIGHT BE articleGroupId
            if (parts.length > 3 && !split.test(parts[3])) {
                model.articleGroupId = parts[3];
                x = 4;
            }

            // Filters
            for (; x < parts.length; x++) {
                let result = split.exec(parts[x]);
                if (result != null) {
                    for (let navigation of this.navigationUrl) {
                        if (navigation.parseUrl(model, x, result[1], result[2]))
                            break;
                    }
                }
            }
        }
        return model;
    }

    public static encodeUrl(url: string) {
        return encodeURIComponent(url);
    }

    public static decodeUrl(url: string) {
        return decodeURIComponent(url);
    }
}

interface ISiteNavigationUrl {
    
    category: string;
    appendUrl(filters: ISiteFilterModel) : string | undefined;
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) : boolean;

}
class SiteNavigationUrlListGroupId
    implements ISiteNavigationUrl {
    
    category = "";

    appendUrl(filters: ISiteFilterModel) {
        // return filters.ListGroupId
        return "";
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        //if (index == 0) {
        //    return true;
        //}
        return false;
    }
}
class SiteNavigationUrlArticleGroupId 
    implements ISiteNavigationUrl {
    
    category = "";
    
    appendUrl(filters: ISiteFilterModel) {
        // return filters.ArticleGroupId
        return "";
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        //if (index == 1) {
        //    return true;
        //}
        return false;
    }
}
class SiteNavigationUrlFavorites
    implements ISiteNavigationUrl {

    category = "Favorites";

    appendUrl(filters: ISiteFilterModel) {
        if (filters.favorites == null)
            return "";
        
        return "" + filters.favorites;
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        if (category == this.category) {
            model.favorites = value === 'true';
            return true;
        }
        return false;
    }
}
class SiteNavigationUrlArticleGroups
    implements ISiteNavigationUrl {
    
    category = "ArticleGroups";
    
    appendUrl(filters: ISiteFilterModel) {
        return filters.articleGroups?.map(a => SiteNavigation.encodeUrl(a)).join(",");
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        if (category == this.category) {
            model.articleGroups = value.split(",").map(a => SiteNavigation.decodeUrl(a));
            return true;
        }
        return false;
    }
}
class SiteNavigationUrlArticleSorts
    implements ISiteNavigationUrl {
    
    category = "ArticleSorts";
    
    appendUrl(filters: ISiteFilterModel) {
        return filters.articleSorts?.map(a => SiteNavigation.encodeUrl(a)).join(",");
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        if (category == this.category) {
            model.articleSorts = value.split(",").map(a => SiteNavigation.decodeUrl(a));
            return true;
        }
        return false;
    }
}
class SiteNavigationUrlLocations
    implements ISiteNavigationUrl {
    
    category = "Locations";
    
    appendUrl(filters: ISiteFilterModel) {
        return filters.locations?.map(a => SiteNavigation.encodeUrl(a)).join(",");
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        if (category == this.category) {
            model.locations = value.split(",").map(a => SiteNavigation.decodeUrl(a));
            return true;
        }
        return false;
    }
}
class SiteNavigationUrlArticleHeight
    implements ISiteNavigationUrl {
    
    category = "ArticleHeight";
    
    appendUrl(filters: ISiteFilterModel) {
        return filters.articleHeight?.map(a => SiteNavigation.encodeUrl(a)).join(",");
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        if (category == this.category) {
            model.articleHeight = value.split(",").map(a => SiteNavigation.decodeUrl(a));
            return true;
        }
        return false;
    }
}
class SiteNavigationUrlArticleWidth
    implements ISiteNavigationUrl {
    
    category = "ArticleWidth";
    
    appendUrl(filters: ISiteFilterModel) {
        return filters.articleWidth?.map(a => SiteNavigation.encodeUrl(a)).join(",");
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        if (category == this.category) {
            model.articleWidth = value.split(",").map(a => SiteNavigation.decodeUrl(a));
            return true;
        }
        return false;
    }
}
class SiteNavigationUrlBaseColors
    implements ISiteNavigationUrl {
    
    category = "BaseColors";
    
    appendUrl(filters: ISiteFilterModel) {
        return filters.baseColors?.map(a => SiteNavigation.encodeUrl(a)).join(",");
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        if (category == this.category) {
            model.baseColors = value.split(",").map(a => SiteNavigation.decodeUrl(a));
            return true;
        }
        return false;
    }
}
class SiteNavigationUrlIndex
    implements ISiteNavigationUrl {
    
    category = "Index";
    
    appendUrl(filters: ISiteFilterModel) {
        return filters.index?.map(a => SiteNavigation.encodeUrl(a)).join(",");
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        if (category == this.category) {
            model.index = value.split(",").map(a => SiteNavigation.decodeUrl(a));
            return true;
        }
        return false;
    }
}
class SiteNavigationUrlListGroups
    implements ISiteNavigationUrl {
    
    category = "ListGroups";
    
    appendUrl(filters: ISiteFilterModel) {
        return filters.listGroups?.map(a => SiteNavigation.encodeUrl(a)).join(",");
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        if (category == this.category) {
            model.listGroups = value.split(",").map(a => SiteNavigation.decodeUrl(a));
            return true;
        }
        return false;
    }
}
class SiteNavigationUrlManufacturerSuppliers
    implements ISiteNavigationUrl {
    
    category = "ManufacturerSuppliers";
    
    appendUrl(filters: ISiteFilterModel) {
        return filters.manufacturerSuppliers?.map(a => SiteNavigation.encodeUrl(a)).join(",");
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        if (category == this.category) {
            model.manufacturerSuppliers = value.split(",").map(a => SiteNavigation.decodeUrl(a));
            return true;
        }
        return false;
    }
}
class SiteNavigationUrlPrice
    implements ISiteNavigationUrl {
    
    category = "Price";
    
    appendUrl(filters: ISiteFilterModel) {
        return filters.price?.map(a => SiteNavigation.encodeUrl(a)).join(",");
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        if (category == this.category) {
            model.price = value.split(",").map(a => SiteNavigation.decodeUrl(a));
            return true;
        }
        return false;
    }
}
class SiteNavigationUrlOrderBy
    implements ISiteNavigationUrl {
    
    category = "OrderBy";
    
    appendUrl(filters: ISiteFilterModel) {
        return filters.orderBy;
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        if (category == this.category) {
            model.orderBy = value;
            return true;
        }
        return false;
    }
}
class SiteNavigationUrlTags
    implements ISiteNavigationUrl {
    
    category = "Tags";
    
    appendUrl(filters: ISiteFilterModel) {
        return filters.tags?.map(a => SiteNavigation.encodeUrl(a)).join(",");
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        if (category == this.category) {
            model.tags = value.split(",").map(a => SiteNavigation.decodeUrl(a));
            return true;
        }
        return false;
    }
}
class SiteNavigationUrlQuery
    implements ISiteNavigationUrl {
    
    category = "Query";
    
    appendUrl(filters: ISiteFilterModel) {
        return filters.query;
    }
    parseUrl(model: ISiteFilterModel, index: number, category: string, value: string) {
        if (category == this.category) {
            model.query = value;
            return true;
        }
        return false;
    }
}